import React, { Suspense } from 'react'
import './SubscriptionRow.css'
import { Subscription } from '../store/store'
import SubscriptionAccounts from './SubscriptionAccounts'
import slugify from 'react-slugify'
import { RequestState } from '../../types'
import SuspenseFallback from '../../../components/layout/SuspenseFallback'
import { useTranslation } from 'react-i18next'
import Date from '../../../components/Date'

type Props = {
  subscription: Subscription
  loadSubscriptionDetails: (subscriptionId: string) => Promise<void>
  setSubscriptionExpanded: (subscriptionId: string, expanded: boolean) => void
  loadSubscriptionAccountFilters: (subscriptionId: string, accountId: string) => Promise<void>
}

function SubcriptionsRow(props: Props) {
  const {
    subscription,
    loadSubscriptionDetails,
    setSubscriptionExpanded,
    loadSubscriptionAccountFilters
  } = props

  const { t } = useTranslation(['tooltips'])

  function toggleExpand() {
    setSubscriptionExpanded(subscription.id, !subscription.isExpanded)

    if (subscription.requestState === RequestState.NotLoaded) {
      loadSubscriptionDetails(subscription.id)
    }
  }

  return (
    <>
      <tr id={slugify(subscription.name)} data-cy="subscription-row" className={subscription.isExpanded ? "expanded" : ""}>
        <td className="toggle">
          {subscription.isExpanded && (
            <i onClick={toggleExpand} className="fa fa-chevron-down expand" aria-hidden="true"></i>
          )}
          {!subscription.isExpanded && (
            <i onClick={toggleExpand} className="fa fa-chevron-right expand" aria-hidden="true"></i>
          )}
        </td>
        <td className={"subscription-description " + (subscription.active ? "" : "inactive")}>
          {subscription.name}
        </td>
        <td className="field subscription-package">
          {subscription.package}
        </td>
        <td className="field subscription-records">
          {subscription.records} / {subscription.recordAllowance}
        </td>
        <td className="field subscription-members">
          {subscription.members}
          {subscription.invitations > 0 ?  `(+${subscription.invitations})` : ''}
          {' / '}
          {subscription.memberAllowance}
        </td>
        <td className="field subscription-renewal">
          <Date date={subscription.renewal as Date} />
        </td>
        <td className="actions">
          <a 
            href={`${process.env.REACT_APP_WEPAPP_URL}/subscriptions/${subscription.id}/overview`} 
            target="_blank" rel="noopener noreferrer"
            title={t('tooltips:open_subscription_webapp')}>
            <i className="far fa-window-maximize icon-button web-expand"></i>
          </a>
          <a 
            href={`${process.env.REACT_APP_MAINFRAME_URL}/subscriptions/${subscription.id}`}
            target="_blank" rel="noopener noreferrer"
            title={t('tooltips:open_subscription_webapp')}>
            <i className="fas fa-cog icon-button"></i>
          </a>
        </td>
      </tr>

      {subscription.isExpanded && (
        <tr className={"expanded expanded-content"}>
          <td />
          <td className="account" colSpan={6}>
            <Suspense fallback={<SuspenseFallback/>}>
            <SubscriptionAccounts
              subscription={subscription}
              loadSubscriptionAccountFilters={loadSubscriptionAccountFilters} />
            </Suspense>
          </td>
        </tr>
      )}
    </>
  )
}

export default SubcriptionsRow
